import * as yup from 'yup';
import { TFunction } from 'i18next';
import { StockOriginType } from 'types/models/StockReceipt';

export const FormSchema = (t: TFunction): any =>
  yup.object().shape({
    venueId: yup.string().required(t('schema.required')),
    receivedAt: yup.date().required(t('schema.required')),
    originSupplierId: yup.mixed().when('originType', {
      is: (value: unknown) => value === StockOriginType.SUPPLIER,
      then: () => yup.number().required(t('schema.required')),
      otherwise: () => yup.number().nullable(),
    }),
    originProductionCenterId: yup.mixed().when('originType', {
      is: (value: unknown) => value === StockOriginType.PRODUCTION_CENTER,
      then: () => yup.string().required(t('schema.required')),
      otherwise: () => yup.string().nullable(),
    }),
    destinationWarehouseId: yup.string().required(t('schema.required')),
    receiptFile: yup.mixed().nullable(),
    purchaseOrderFile: yup.mixed().nullable(),
  });
